// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuickStartGuide-module__headerLine--AvxSc{display:none}.QuickStartGuide-module__card--XUYAL{display:flex;flex-direction:column;margin:0}.QuickStartGuide-module__card--XUYAL:not(:last-of-type){margin-bottom:1rem}.QuickStartGuide-module__card--XUYAL>* a,.QuickStartGuide-module__card--XUYAL>* button{display:block;margin-top:.5rem}.QuickStartGuide-module__quickStartGuide--hc1nx{flex:1 1 auto;padding:1rem;overflow-y:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerLine": "QuickStartGuide-module__headerLine--AvxSc",
	"card": "QuickStartGuide-module__card--XUYAL",
	"quickStartGuide": "QuickStartGuide-module__quickStartGuide--hc1nx"
};
export default ___CSS_LOADER_EXPORT___;
